import type { ImportPreparedPageResultV1 } from 'fredrick-local-repository';

/**
 * Schedule repository processing before consulting component lifetime. Import
 * persistence is durable work and must not depend on whether the initiating UI
 * is still mounted; only the subsequent view update is mount-scoped.
 */
export function continuePersistedImportForMountedView(
  result: ImportPreparedPageResultV1,
  scheduleProcessing: () => void,
  isMounted: () => boolean,
): ImportPreparedPageResultV1 | null {
  if (result.disposition === 'created') scheduleProcessing();
  return isMounted() ? result : null;
}
